import experiment from 'experiment';
import * as stateManagement from '#packages/stateManagement';
import { BasePublicApi } from '#packages/apilib';
import type { StudioMigrationManagerScope } from './studioMigrationManagerScope';

const shouldBlockPublishForStudioMigration = (
  scope: StudioMigrationManagerScope,
): boolean => {
  const { editorAPI } = scope;

  const isClassicToStudioExperimentEnabled = experiment.isOpen(
    'specs.responsive-editor.classicToStudio',
  );
  if (!isClassicToStudioExperimentEnabled) {
    return false;
  }

  const state = editorAPI.store.getState();
  return stateManagement.branches.selectors.getDsHasPublishedStudioBranch(
    state,
  );
};

export class StudioMigrationManagerApi extends BasePublicApi<StudioMigrationManagerScope> {
  shouldBlockPublishForStudioMigration = this.bindScope(
    shouldBlockPublishForStudioMigration,
  );
}
